

const createMemberInfo = (name, fullname, pos, img, desc, history) => ({
  name,
  fullname,
  pos,
  img,
  desc,
  history,
});

export default createMemberInfo;